import { DATA_TYPE } from "Api/constants";

/**
 * @typedef {FileData} FileData
 * @property {Blob} file
 * @property {String} fileName
 * @property {DATA_TYPE} dataType
 * @property {String|Number} index
 * @property {String} password
 */

/**
 * @param file {Object}
 * @param fileName {String}
 * @param dataType {DATA_TYPE}
 * @param password {String}
 * @param index {Number|String}
 * @returns {FileData}
 */
export function FileData(file, fileName, dataType, password, index, modified) {
    let _this = this;
    this.file = file;
    this.modified = modified
    this.fileName = fileName;
    this.dataType = dataType;
    this.index = index;
    this.password = password?password:'';
    this.getSize = ()=>{
        let size = 0;
        switch (_this.dataType) {
            case DATA_TYPE.FileBuffer:
                if(_this.file instanceof Array){
                    _this.file.map((buffer)=>{
                        size += buffer.byteLength;
                    })
                }else if(_this.file instanceof ArrayBuffer){
                    size = _this.file.byteLength;
                }
                break;
            case DATA_TYPE.File:{
                size = _this.file.size;
            }
            default:
                break;
        }
        return size;
    }
    this.clean = ()=>{
        _this.file = null;
    }
    return this;
}